import { SxProps, Theme } from '@mui/material/styles';

export const SX_MENU: SxProps<Theme> = {
  display: { lg: 'flex', xs: 'none' },
  flexGrow: 1,
  justifyContent: 'space-between',
};

export const SX_SUBMENU: SxProps<Theme> = {
  flexGrow: 1,
};

export const SX_SUBMENU_RIGHT: SxProps<Theme> = {
  ...SX_SUBMENU,
  textAlign: 'right',
};

export const SX_ROUTE: SxProps<Theme> = {
  color: '#fff',
  fontSize: '.75rem',
  fontWeight: '600',
  letterSpacing: '2px',
  lineHeight: '1rem',
  textShadow: '0 0 4px var(--nav-shadow), 0 0 4px var(--nav-shadow)',
  textTransform: 'uppercase',
};

export const SX_ROUTE_LEFT: SxProps<Theme> = {
  ...SX_ROUTE,
  marginRight: '1.75rem',
};

export const SX_ROUTE_RIGHT: SxProps<Theme> = {
  ...SX_ROUTE,
  marginLeft: '1.75rem',
};
